import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import type { LeadDetails } from '../../types/quiz';
interface LeadFormProps {
  onSubmit: (details: LeadDetails) => void;
}
const fields: Array<{
  key: keyof LeadDetails;
  label: string;
  type: string;
  placeholder: string;
  autoComplete: string;
}> = [{
  key: 'nombre',
  label: 'Nombre',
  type: 'text',
  placeholder: 'Tu nombre',
  autoComplete: 'name'
}, {
  key: 'email',
  label: 'Email',
  type: 'email',
  placeholder: 'tucorreo@email.com',
  autoComplete: 'email'
}, {
  key: 'whatsapp',
  label: 'WhatsApp',
  type: 'tel',
  placeholder: '+00 000 000 000',
  autoComplete: 'tel'
}];
export function LeadForm({
  onSubmit
}: LeadFormProps) {
  const [values, setValues] = useState<LeadDetails>({
    nombre: '',
    email: '',
    whatsapp: ''
  });
  const [errors, setErrors] = useState<Partial<Record<keyof LeadDetails, string>>>({});
  const validate = () => {
    const next: Partial<Record<keyof LeadDetails, string>> = {};
    if (!values.nombre.trim()) next.nombre = 'Escribe tu nombre.';
    if (!/^\S+@\S+\.\S+$/.test(values.email.trim())) next.email = 'Escribe un email válido.';
    if (values.whatsapp.replace(/\D/g, '').length < 7) next.whatsapp = 'Escribe un número válido.';
    setErrors(next);
    return Object.keys(next).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) onSubmit(values);
  };
  return <form onSubmit={handleSubmit} className="text-left" noValidate data-id="element-236" data-mp="flzzh9zv7beo">
      <div className="text-center" data-id="element-237" data-mp="ke1jxj76s8fs">
        <Sparkles className="mx-auto h-6 w-6 text-gold" strokeWidth={1.25} aria-hidden="true" data-id="element-238" data-mp="ket848ygf3w1" />
        <h3 className="mt-4 font-serif text-2xl font-light leading-snug text-ink sm:text-3xl" data-id="element-239" data-mp="peyzdo0taodl">
          ¿Dónde puedo enviarte tu resultado?
        </h3>
        <p className="mx-auto mt-4 max-w-md text-[16px] leading-relaxed text-ink-soft" data-id="element-240" data-mp="za90m9jdyrqb">
          Tus respuestas también me ayudarán a comprender mejor tu momento
          actual antes de nuestra conversación.
        </p>
      </div>

      <div className="mt-8 space-y-5" data-id="element-241" data-mp="4pmyim9p551k">
        {fields.map(field => <div key={field.key} data-id="element-242" data-mp="jdhucbj03piv">
            <label htmlFor={`lead-${field.key}`} className="block text-[10px] font-semibold uppercase tracking-[0.22em] text-gold-dark" data-id="element-243" data-mp="jesyicgcyzai">
              {field.label}
            </label>
            <input id={`lead-${field.key}`} type={field.type} autoComplete={field.autoComplete} placeholder={field.placeholder} value={values[field.key]} onChange={e => {
          setValues(v => ({
            ...v,
            [field.key]: e.target.value
          }));
          if (errors[field.key]) setErrors(prev => ({
            ...prev,
            [field.key]: undefined
          }));
        }} aria-invalid={Boolean(errors[field.key])} aria-describedby={errors[field.key] ? `lead-${field.key}-error` : undefined} className={`mt-2 w-full rounded-xl border bg-ivory px-4 py-3.5 text-[15px] text-ink placeholder:text-ink-muted transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gold/40 ${errors[field.key] ? 'border-red-400' : 'border-gold/30'}`} data-id="element-244" data-mp="nejuqvonm7mf" />
            {errors[field.key] && <p id={`lead-${field.key}-error`} className="mt-1.5 text-[12.5px] text-red-500" data-id="element-245" data-mp="zwxa76osfnxl">
                {errors[field.key]}
              </p>}
          </div>)}
      </div>

      <button type="submit" className="btn-gold mt-8 w-full rounded-full px-8 py-4 text-[11px] font-semibold uppercase tracking-[0.18em] sm:text-xs" data-id="element-246" data-mp="qx0kr2ukql1h">
        Ver mi resultado
      </button>
    </form>;
}